// extracted by mini-css-extract-plugin
export default {"storeNameClass":"style-module--storeNameClass--Zcr7g"};